import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoadingIcon from '../../../common/icons/LoadingIcon';

import sectionStyles from './_styles/DashboardSection.module.scss';
import styles from './_styles/DashboardAttributes.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class DashboardAttributes extends Component {

	constructor(props) {
		super(props);
		this.state = {
			requestPending: false,
			requestData: [],
		};
	}

	componentDidMount() {
		this.fetchAttributes();
	}

	async fetchAttributes() {
		this.setState({ requestPending: true });
		try {
			const productTotals = await this.props.ddnyFetchAttributeTotals();
			this.setState({ requestData: productTotals });
		} catch(err) {
			console.error(err);
		} finally {
			this.setState({ requestPending: false });
		}
	}

	render() {
		return <div className={`${styles.DashboardAttributes} ${sectionStyles.DashboardSection}`}>
			<div className={sectionStyles.titleWrapper}>
				<div className={sectionStyles.title}>Attributes</div>
			</div>
			<div className={`${sectionStyles.body}`}>
				{this.state.requestPending
					?	<div className={sectionStyles.loading}>
							<div className={sectionStyles.iconWrapper}>
								<LoadingIcon />
							</div>
						</div>
					:	<div className={sectionStyles.loaded}>
							<div className={styles.tableWrapper}>
								{this.state.requestData.map((attr, i) => {
									return <div key={i} className={styles.row}>
										<div className={styles.rowLiner}>
											<div className={styles.label}>{attr.type?.name || ''}</div>
											<div className={styles.value}>{attr.count || 0}</div>
										</div>
									</div>
								})}
							</div>
						</div>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(DashboardAttributes);